<template>
  <section class="instagram-section">

    <div class="instagram-header">
      <span class="subtitle">✨ EVERMORE MOMENTS ✨</span>

      <h2>Síguenos en Instagram</h2>
      <p>
        Descubre novedades, lanzamientos, eventos y nuestros productos favoritos.
      </p>

      <a
        href="https://www.instagram.com/evermore_beauty_store/"
        target="_blank"
        class="instagram-button"
      >
        ✧ Ver Insta ✧ 
      </a>

      <a href="https://www.instagram.com/evermore_beauty_store/" target="_blank" class="btn-glow"> </a>

    </div>

    <div class="instagram-grid">
      <a
        v-for="post in instagramPosts"
        :key="post.id"
        :href="post.link"
        target="_blank"
        class="post-card"
      >
        <img
          :src="post.image"
          :alt="post.title"
        />
      </a>
    </div>

  </section>
</template>


<script setup>
import post1 from '@/assets/instagram/post1.jpg'


const instagramPosts = [
  {
    id: 1,
    image: post1,
    link: "https://instagram.com/p/DWc0bGxgNX_/?img_index=1"
  },
  {
    id: 2,
    image: "@/assets/instagram/post2.jpg",
    link: "https://instagram.com/"
  },
  {
    id: 3,
    image: "/instagram/post3.jpg",
    link: "https://instagram.com/"
  },
  {
    id: 4,
    image: "/instagram/post4.jpg",
    link: "https://instagram.com/"
  },
  {
    id: 5,
    image: "/instagram/post5.jpg",
    link: "https://instagram.com/"
  },
  {
    id: 6,
    image: "/instagram/post6.jpg",
    link: "https://instagram.com/"
  }
]

</script>

<style>
.instagram-section{
  background:#000813;
  padding:90px 8%;
}

.instagram-header{
  text-align:center;
  max-width:500px;
  margin:auto;
}

.subtitle{
  color:#5faeff;
  font-weight:500;
  letter-spacing:2px;
}

.instagram-header h2{
  font-size:3rem;
  color:#11146D;
  margin-top:15px;
}

.instagram-header p{
  color:#555;
  margin-top:10px;
  margin-bottom:30px;
}

.instagram-button{
  display:inline-block;
  color:white;
  text-decoration:none;
  padding:14px 28px;
  border-radius:999px;
  transition:.3s;

  font-family: "Magistral_Bold";
  font-size: clamp(13px, 2.5vw, 19px);
  background: rgba(6, 93, 255, 0.704);
  backdrop-filter: blur(8px);
  text-decoration: wavy;
}

.instagram-button:hover{
  transform:translateY(-3px);
  animation: glowPulse 1.5s infinite alternate;/* pulso */ 
}

@keyframes glowPulse {
  from {
    box-shadow: 0 0 5px #c4b5fd;
  }
  to {
    box-shadow: 0 0 20px #c4b5fd;
    }
  }


.instagram-grid{
  margin-top:60px;
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:20px;
}

.post-card{
  overflow:hidden;
  border-radius:25px;
}

.post-card img{
  width:100%;
  height:100%;
  object-fit:cover;

  aspect-ratio:1/1;

  transition:.4s;
}

.post-card:hover img{
  transform:scale(1.05);
}



</style>